import React from "react";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { StaggerGroup, StaggerItem } from "@/components/shared/Reveal";
import { CTAButton } from "@/components/shared/CTAButton";
import { SERVICES } from "@/data/site";

export const ServiceCard = ({ icon: Icon, title, desc }) => (
  <div
    className="group relative h-full rounded-3xl border border-gray-100 bg-white p-7 shadow-soft transition-transform duration-300 hover:-translate-y-1.5 hover:shadow-card"
    data-testid={`service-card-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
  >
    <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-light text-brand transition-colors duration-300 group-hover:bg-brand group-hover:text-white">
      <Icon className="h-7 w-7" />
    </div>
    <h3 className="mt-6 font-heading font-bold text-xl text-ink">{title}</h3>
    <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{desc}</p>
    <span className="mt-5 inline-block h-0.5 w-8 bg-brand-accent/30 transition-all duration-300 group-hover:w-14 group-hover:bg-brand-accent" />
  </div>
);

export const ServicesGrid = () => {
  return (
    <section className="bg-surface py-24 lg:py-32" data-testid="services">
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <SectionHeading
            eyebrow="What we do"
            title="A full-stack logistics partner."
            description="From a single carton to enterprise supply chains — twelve specialised services under one trusted roof."
          />
          <CTAButton to="/services" variant="outline" arrow className="shrink-0">All Services</CTAButton>
        </div>

        <StaggerGroup className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {SERVICES.map((s) => (
            <StaggerItem key={s.title} className="h-full">
              <ServiceCard {...s} />
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
};
